import { render } from "./BMICalc.vue?vue&type=template&id=1f89d190"
import script from "./BMICalc.vue?vue&type=script&lang=js"
export * from "./BMICalc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__